import Phaser from 'phaser';
import { Enemy } from './Enemy';
import type { EnemyConfig } from './Enemy';

export class AngryBacon extends Enemy {
  private sizzleTime: number = 0;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    const config: EnemyConfig = {
      texture: 'angryBacon',
      points: 20,
      health: 1,
      fireRate: 1500, // Faster fire rate
      projectileSpeed: 250, // Faster projectiles
      projectileTexture: 'greaseProjectile',
    };

    super(scene, x, y, config);
    
    // Set hitbox size (wider, shorter)
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setSize(36, 20);
    
    // Random starting phase
    this.sizzleTime = Math.random() * Math.PI * 2;
  }

  update(_time: number, delta: number): void {
    // Sizzle animation - slight shake
    this.sizzleTime += delta * 0.01;
    this.x += Math.sin(this.sizzleTime * 2) * 0.3;
    this.rotation = Math.sin(this.sizzleTime) * 0.05;
  }
}






